import { createSelector } from 'reselect';
import { RootState } from '..';

const _getNotificationState = ({ notificationReducer }: RootState) =>
  notificationReducer;
export const getNotificationState = createSelector(
  _getNotificationState,
  state => state
);
